
import React from 'react';
import { cn } from '@/lib/utils';

interface TaskCardDescriptionProps {
  description?: string;
  isCompleted: boolean;
}

const TaskCardDescription = ({ description, isCompleted }: TaskCardDescriptionProps) => {
  if (!description) return null;
  
  return (
    <div className="mb-3 pb-1" style={{ overflow: 'hidden' }}>
      <p 
        className={cn(
          "text-sm transition-all duration-200",
          isCompleted ? "text-muted-foreground/40" : "text-muted-foreground"
        )}
        style={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          wordBreak: 'break-word'
        }}
        title={description} // Show full description on hover
      >
        {description}
      </p>
    </div>
  );
};

export default TaskCardDescription;
